import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AngularFireAuth } from 'angularfire2/auth';
import { User as FirebaseUser } from 'firebase';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/first';

import { User } from '../models/user';

import { UserService } from '../services/user.service';

@Injectable()
export class CompaniesGuardService implements CanActivate, CanActivateChild {

  constructor(
    private afAuth: AngularFireAuth,
    private userService: UserService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return Observable.create((observer: Observer<boolean>) => {
      this.afAuth.authState
        .first()
        .subscribe((firebaseUser: FirebaseUser | null) => {
          if (firebaseUser) {
            this.userService.getUser(firebaseUser.uid)
              .first()
              .subscribe((user: User | null) => {
                if (user) {
                  observer.next(user.roleIsThinkBIT || false);
                } else {
                  observer.next(false);
                }

                observer.complete();
              });
          } else {
            observer.next(false);
            observer.complete();
          }
        });
    });
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(childRoute, state);
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/services/companies-guard.service.ts